import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Sparkles, Lock } from "lucide-react";
import { brandApi, setBrandAuth } from "../lib/brandPortalApi";
import { errMsg } from "../lib/api";

export default function BrandLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await brandApi.post("/brand/auth/login", { email, password });
      setBrandAuth(data.token, data.brand);
      toast.success(`Welcome, ${data.brand.name}!`);
      nav("/brand-portal");
    } catch (err) {
      toast.error(errMsg(err, "Login failed"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#070A14] grid place-items-center px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-indigo-500/15 border border-indigo-400/30 text-indigo-300 text-[11px] font-bold uppercase tracking-wider">
            <Sparkles className="w-3.5 h-3.5" /> BrandsByIndia Portal
          </div>
          <h1 className="text-white text-3xl font-semibold mt-5 tracking-tight">Brand Login</h1>
          <p className="text-slate-400 text-sm mt-2">Track your brand page, articles and visibility stats.</p>
        </div>
        <form onSubmit={submit} className="bg-white/[0.04] border border-white/10 rounded-2xl p-7 space-y-4">
          <div>
            <label className="text-xs text-slate-400 font-semibold uppercase tracking-wider">Email</label>
            <input
              data-testid="brand-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 w-full bg-white/[0.05] border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-indigo-400/60"
              placeholder="brand@example.com"
            />
          </div>
          <div>
            <label className="text-xs text-slate-400 font-semibold uppercase tracking-wider">Password</label>
            <input
              data-testid="brand-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 w-full bg-white/[0.05] border border-white/10 rounded-xl px-4 py-3 text-sm text-white placeholder:text-slate-600 focus:outline-none focus:border-indigo-400/60"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="brand-login-submit"
            disabled={busy}
            className="w-full py-3 rounded-xl bg-gradient-to-r from-indigo-500 to-fuchsia-500 text-sm font-semibold disabled:opacity-60 flex items-center justify-center gap-2"
            style={{ color: "#FFFFFF" }}
          >
            <Lock className="w-4 h-4" /> {busy ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="text-center text-xs text-slate-500 mt-6">
          Credentials are provided by your EcomCatalog AI account manager.
        </p>
      </div>
    </div>
  );
}
